import produce from 'immer';
import { basePlanningBoardActions } from '../actions';
import {
  FilterListsResponse,
  FilterListsResponse2,
  MetaPagination,
  ProfileResponse,
  ProfileResponse2,
} from '../../../api';

export interface PlanningBoardState {
  list: {
    data: Array<ProfileResponse> | Array<ProfileResponse2>;
    filters: FilterListsResponse | FilterListsResponse2 | undefined;
    pagination: MetaPagination | undefined;
    ok: boolean | undefined;
  };
}

export const PLANNING_BOARD_INIT_STATE: PlanningBoardState = {
  list: {
    data: [],
    filters: undefined,
    pagination: undefined,
    ok: undefined,
  },
};

export function BasePlanningBoardReducer(state: PlanningBoardState = PLANNING_BOARD_INIT_STATE, action: any): any {
  if (action.type === basePlanningBoardActions.resetPlanningBoard.type) {
    return PLANNING_BOARD_INIT_STATE;
  }
  return produce(state, (draftState) => {
    switch (action.type) {
      case basePlanningBoardActions.loadPlanningBoardList.type:
        draftState.list.ok = undefined;
        draftState.list.data = [];
        return;

      case basePlanningBoardActions.setPlanningBoardList.type:
        draftState.list.data = action.payload;
        return;

      case basePlanningBoardActions.setPlanningBoardFiltersAndPagination.type:
        draftState.list.filters = action.payload.filters;
        draftState.list.pagination = action.payload.pagination;
        return;

      case basePlanningBoardActions.successLoadPlanningBoardList.type:
        draftState.list.ok = true;
        return;

      case basePlanningBoardActions.errorLoadPlanningBoardList.type:
        draftState.list.ok = false;
        return;
    }
  });
}
